export default __webpack_public_path__ + "media/images/features/toyono/main_logo-b57dbb0304130eb68e0129a7df978914.png";